import {
  TreeViewSidebarContent,
  TreeViewSidebarLayout,
} from "./custom-sidebar";

export const TreeViewSidebarError = () => {
  return (
    <TreeViewSidebarLayout>
      <TreeViewSidebarContent>
        <div className="flex flex-col items-center justify-center h-full p-4">
          <div className="text-red-500 text-center">
            <span className="block mb-2"></span>
            <span className="text-sm text-neutral-500">
              잠시 후 다시 시도해주세요.
            </span>
          </div>
        </div>
      </TreeViewSidebarContent>
    </TreeViewSidebarLayout>
  );
};

export const TreeViewSidebarEmpty = () => {
  return (
    <TreeViewSidebarLayout>
      <TreeViewSidebarContent>
        <div className="flex flex-col items-center justify-center h-full p-4">
          <span className="text-neutral-500">
            축과 열을 선택 후 다시 시도해주세요.
          </span>
        </div>
      </TreeViewSidebarContent>
    </TreeViewSidebarLayout>
  );
};

export const TreeViewSidebarLoading = () => {
  return (
    <TreeViewSidebarLayout>
      <TreeViewSidebarContent>
        <div className="flex flex-col gap-2 p-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="animate-pulse">
              <div className="h-8 bg-neutral-200 rounded mb-2" />
              <div className="space-y-2">
                <div className="h-6 bg-neutral-100 rounded w-3/4" />
                <div className="h-6 bg-neutral-100 rounded w-2/3" />
                <div className="h-6 bg-neutral-100 rounded w-4/5" />
              </div>
            </div>
          ))}
        </div>
      </TreeViewSidebarContent>
    </TreeViewSidebarLayout>
  );
};
